import Link, { isAllowedUri } from "@tiptap/extension-link";

export const CustomLink = Link.extend({
  renderHTML({ mark, HTMLAttributes }) {
    const isSafeHref = this.options.isAllowedUri(HTMLAttributes.href, {
      defaultValidate: (href) => !!isAllowedUri(href, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol,
    });

    // a 태그에 마우스를 올렸을 때 기본 툴팁(title)으로 href 값이 나오도록 설정
    const title = isSafeHref ? HTMLAttributes.title || HTMLAttributes.href : "";
    return (
      this.parent?.({ mark, HTMLAttributes: { ...HTMLAttributes, title } }) ?? [
        "a",
        { ...HTMLAttributes, href: isSafeHref ? HTMLAttributes.href : "", title },
        0,
      ]
    );
  },
});
